if( document.querySelectorAll('.bottom_products_slider').length > 0 ){
  var mySwiper = new Swiper('.bottom_products_slider.swiper-container', {
      freeMode: true,
      slidesPerView: 2.1,
      spaceBetween: 3,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          1025: {
              slidesPerView: 2.5,
              spaceBetween: 3
          },
          768: {
              slidesPerView: 2.1,
              spaceBetween: 2
          },
          320: {
              slidesPerView: 2.22,
              spaceBetween: 2
          }
      }
  });
}
if( document.querySelectorAll('.bestseller_products_slider').length > 0 ){
  var mySwiper = new Swiper('.bestseller_products_slider.swiper-container', {
      freeMode: true,
      slidesPerView: 4,
      loop: false,
      spaceBetween: 3,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      breakpoints: {
          1025: {
              slidesPerView: 4,
              loop: false,
              spaceBetween: 3
          },
          768: {
              slidesPerView: 3,
              loop: false,
              spaceBetween: 3
          },
          320: {
              slidesPerView: 1.70,
              loop: false,
              spaceBetween: 3
          }
      }
  });
}